'use client';

import walletStore from '@/src/stores/walletStore';
import styles from './userInfo.module.css';

export const UserInfo = () => {
  const { user } = walletStore();

  if (!user) {
    return null;
  }

  return (
    <div className={styles.userInfo}>
      <div className={styles.userInfoTitle}>{user.displayName}</div>
      <div className={styles.userInfoSubtitle}>{user.primaryZID}</div>
    </div>
  );
};
